import { render } from "./HomepageUmons.vue?vue&type=template&id=bd1e3daa&scoped=true"
import script from "./HomepageUmons.vue?vue&type=script&lang=js"
export * from "./HomepageUmons.vue?vue&type=script&lang=js"

import "./HomepageUmons.vue?vue&type=style&index=0&id=bd1e3daa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd1e3daa"]])

export default __exports__